module.exports = __webpack_public_path__ + "img/hm.580ea444.png";